import React, { useState } from "react";
import { Row, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import { FiFileText, FiCalendar } from "react-icons/fi";
// import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import PipelineStagesCard from "../../../components/Dashboard/deals-dashboard/PipelineStagesCard";
import DealsStatsCard from "../../../components/Dashboard/deals-dashboard/DealsStatsCard";
import DealsByStage from "../../../components/Dashboard/deals-dashboard/DealsByStage";
import DealsByCompanies from "../../../components/Dashboard/deals-dashboard/DealsByCompanies";
import TopDealsChart from "../../../components/Dashboard/deals-dashboard/TopDealsChart";
import DealsByCountriesCard from "../../../components/Dashboard/deals-dashboard/DealsByCountriesCard";
import WonDealsStagCard from "../../../components/Dashboard/deals-dashboard/WonDealsStageCard";
import RecentFollupsCard from "../../../components/Dashboard/deals-dashboard/DealsFollupsCard";
import RecentDealsCard from "../../../components/Dashboard/deals-dashboard/RecentDealsCard";
import RecentActivitiesCard from "../../../components/Dashboard/deals-dashboard/RecentActivitiesCard";
import { IoIosArrowDown } from "react-icons/io";
import { RiHome6Line } from "react-icons/ri";

export default function DealsDashboardPage() {
  const [rangeLabel, setRangeLabel] = useState("Last 7 Days");
  const [dateRange, setDateRange] = useState("03/11/2026 - 03/17/2026");
  const [filter, setFilter] = useState("This Week");
  // DATE HANDLER
  const handleRangeChange = (type) => {
    const today = new Date();

    const format = (d) =>
      `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
        d.getDate(),
      ).padStart(2, "0")}/${d.getFullYear()}`;

    let start, end;

    switch (type) {
      case "Today":
        start = end = new Date();
        break;

      case "Yesterday":
        start = end = new Date();
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;

      case "Last 7 Days":
        end = new Date();
        start = new Date();
        start.setDate(end.getDate() - 6);
        break;

      case "Last 30 Days":
        end = new Date();
        start = new Date();
        start.setDate(end.getDate() - 29);
        break;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today.getFullYear(), 11, 31);
        break;

      default:
        return;
    }

    setRangeLabel(type);
    setDateRange(`${format(start)} - ${format(end)}`);
  };

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}
      className="page-breadcrumb mb-3"
    >
      <Row className="align-items-center justify-content-between">
        {/* LEFT SIDE (UNCHANGED) */}
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Deals Dashboard
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="text-dark"
                  style={{ fontSize: "1.2rem" }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Deals Dashboard</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE (UPDATED DESIGN) */}
        <Col md={6}>
          <div className="toolbar">
            {/* EXPORT */}
            <Dropdown>
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                className="toolbar-btn"
              >
                <FiFileText className="icon" />
                Export
                <IoIosArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="dropdown-box">
                <Dropdown.Item>Export as PDF</Dropdown.Item>
                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* DATE RANGE */}
            <Dropdown>
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                className="toolbar-btn"
              >
                <FiCalendar className="icon" />
                {dateRange}
                <IoIosArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="date-dropdown">
                {[
                  "Today",
                  "Yesterday",
                  "Last 7 Days",
                  "Last 30 Days",
                  "This Year",
                ].map((item) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => handleRangeChange(item)}
                    className={rangeLabel === item ? "active-item" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>

        <div className="dashboard-container">
          <Row>
            {/* LEFT */}
            <Col xl={6} lg={12}>
              <PipelineStagesCard filter={filter} setFilter={setFilter} />
            </Col>

            {/* RIGHT */}
            <Col xl={6} lg={12}>
              <Row className="g-3 responsive-gap">
                <Col md={6}>
                  <DealsStatsCard
                    title="Total Deals"
                    value="$45,221,45"
                    percent="-4.01%"
                    trend="down"
                    color="orange"
                    progress={70}
                  />
                </Col>

                <Col md={6}>
                  <DealsStatsCard
                    title="Total Customers"
                    value="9895"
                    percent="+55%"
                    trend="up"
                    color="purple"
                    progress={65}
                  />
                </Col>

                <Col md={6}>
                  <DealsStatsCard
                    title="Deal Value"
                    value="$12,545,68"
                    percent="+20.01%"
                    trend="up"
                    color="teal"
                    progress={80}
                  />
                </Col>

                <Col md={6}>
                  <DealsStatsCard
                    title="Conversion Rate"
                    value="51.96%"
                    percent="-6.01%"
                    trend="down"
                    color="blue"
                    progress={60}
                  />
                </Col>

                <Col md={6}>
                  <DealsStatsCard
                    title="Revenue this month"
                    value="$46,548,48"
                    percent="+55%"
                    trend="up"
                    color="pink"
                    progress={75}
                  />
                </Col>

                <Col md={6}>
                  <DealsStatsCard
                    title="Active Customers"
                    value="8987"
                    percent="-3.22%"
                    trend="down"
                    color="yellow"
                    progress={65}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          {/* CSS */}
          <style>{`
        .dashboard-container {
          padding: 15px;
          background: #f8f9fa;
        }

        @media (max-width:1024px){
          .responsive-gap > div{
            margin-top:15px;
          }
        }
      `}</style>
        </div>

        <Row className="mt-3">
          <Col xl={4} lg={6} md={12}>
            <DealsByStage className="g-3 responsive-gap" />
          </Col>

          <Col xl={4} lg={6} md={12}>
            <DealsByCompanies className="g-3 responsive-gap" />
          </Col>

          <Col xl={4} lg={12} md={12}>
            <TopDealsChart className="g-3 responsive-gap" />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xl={4} className="d-flex mb-3 mb-xl-0">
            <DealsByCountriesCard />
          </Col>

          <Col xl={4} className="d-flex mb-3 mb-xl-0">
            <WonDealsStagCard />
          </Col>

          <Col xl={4} className="d-flex">
            <RecentFollupsCard />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xl={8} className="d-flex mb-3 mb-xl-0">
            <RecentDealsCard />
          </Col>

          <Col xl={4} className="d-flex mb-3 mb-xl-0">
            <RecentActivitiesCard />
          </Col>
        </Row>
      </Row>

      {/* CLEAN CSS */}
      <style>{`
        .toolbar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .toolbar-btn {
          background: #f3f4f6 !important;
          border: 1px solid #e5e7eb !important;
          border-radius: 10px !important;
          padding: 8px 14px !important;
          font-size: 14px !important;
          display: flex;
          align-items: center;
          gap: 6px;
          color: #111827;
        }

        .toolbar-btn:hover {
          background: #ffe7d6 !important;
          color: #f97316 !important;
          border-color: #f97316 !important;
        }

        .icon {
          font-size: 16px;
        }

        .dropdown-box {
          border-radius: 10px;
          padding: 6px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
        }

        .dropdown-box .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-box .dropdown-item:hover {
          background: #fff3ed;
          color: #f97316;
        }

        .date-dropdown {
          padding: 10px;
          border-radius: 12px;
          width: 220px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .date-dropdown .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
          padding: 8px 10px;
        }

        .date-dropdown .dropdown-item:hover {
          background: #fff3ed;
          color: #f97316;
        }

        .active-item {
          background: #f97316 !important;
          color: #fff !important;
        }
      `}</style>
    </div>
  );
}
